/*global jQuery */

import './style.scss'
import search from './search/index'
import accessibility from './helpers/accessibility'

jQuery(function(){
    "use strict";

    // Search trigger and overlay
    search.addSearchToNavigation();
    search.searchOverlayTrigger();

    // Accessibility fixes
    accessibility.init_a11y_fixes();
});



// WEBPACK FOOTER //
// ./front-end/src/index.js